import { createReducer, } from 'typesafe-actions';

import {
    UPDATE_CART_SHOP,
    ShopCartItem,
} from './types';
const shopCartInitialState: Array<ShopCartItem> = [];

const shopCartReducer = createReducer(shopCartInitialState)
    .handleAction(UPDATE_CART_SHOP, (state: any, action: any) => action.data || []);

export default shopCartReducer;
